import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSuppliers, createSupplier, updateSupplier, removeSupplier } from '../features/supplier/supplierSlice';
import { useNavigate } from 'react-router-dom';
import { useModalEscape } from '../utils/useModalEscape';

const Suppliers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items, loading } = useSelector((s) => s.supplier);
  const [q, setQ] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nombre: '', docTipo: 80, docNro: '', condicionIVA: 1, email: '', telefono: '', direccion: '' });

  useEffect(() => { dispatch(fetchSuppliers({})); }, [dispatch]);

  // ESC key handler for modal
  useModalEscape(modalOpen, () => setModalOpen(false));

  const openNew = () => { setEditing(null); setForm({ nombre: '', docTipo: 80, docNro: '', condicionIVA: 1, email: '', telefono: '', direccion: '' }); setModalOpen(true); };
  const openEdit = (s) => { setEditing(s); setForm({ nombre: s.nombre, docTipo: s.docTipo||80, docNro: s.docNro||'', condicionIVA: s.condicionIVA||1, email: s.email||'', telefono: s.telefono||'', direccion: s.direccion||'' }); setModalOpen(true); };
  const onSubmit = (e) => {
    e.preventDefault();
    if (editing) {
      dispatch(updateSupplier({ id: editing._id, data: form })).then(() => setModalOpen(false));
    } else {
      dispatch(createSupplier(form)).then(() => setModalOpen(false));
    }
  };

  const onDelete = (s) => { if (window.confirm('¿Eliminar proveedor?')) dispatch(removeSupplier(s._id)); };
  const onSearch = (e) => { e.preventDefault(); dispatch(fetchSuppliers({ q })); };

  return (
    <div className="container-safe" style={{ padding: 20, maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate('/dashboard')} style={btn('#718096')}>← Volver</button>
          <h2 style={{ margin: 0 }}>📦 Proveedores</h2>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <form onSubmit={onSearch} style={{ display: 'flex', gap: 8 }}>
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nombre o CUIT" style={input}/>
            <button type="submit" style={btn('#667eea')}>Buscar</button>
          </form>
          <button onClick={openNew} style={btn('#28a745')}>➕ Nuevo</button>
        </div>
      </div>

      <div style={card}>
        {loading ? (
          <p>Cargando...</p>
        ) : items.length === 0 ? (
          <p style={{ padding: 20, textAlign: 'center', color: '#666' }}>No hay proveedores</p>
        ) : (
          <>
          {/* Vista móvil como tarjetas */}
          <div className="show-on-mobile" style={{ display: 'grid', gap: 10, padding: 10 }}>
            {items.map(s => (
              <div key={s._id} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <strong>{s.nombre}</strong>
                </div>
                <div style={{ fontSize: 13, color: '#555', marginTop: 6 }}>
                  <div><strong>Doc:</strong> {s.docTipo || 80}-{s.docNro || ''}</div>
                  <div><strong>Cond. IVA:</strong> {s.condicionIVA}</div>
                  <div><strong>Contacto:</strong> {s.email || '-'}{s.telefono ? ` / ${s.telefono}` : ''}</div>
                  {s.direccion && (<div><strong>Dirección:</strong> {s.direccion}</div>)}
                </div>
                <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                  <button onClick={() => openEdit(s)} style={btn('#6f42c1')}>✏️ Editar</button>
                  <button onClick={() => onDelete(s)} style={btn('#dc3545')}>🗑️ Eliminar</button>
                </div>
              </div>
            ))}
          </div>

          {/* Vista escritorio con tabla */}
          <div className="responsive-table hide-on-mobile">
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
                  <th style={th}>Nombre</th>
                  <th style={th}>Doc</th>
                  <th style={th}>Cond. IVA</th>
                  <th style={th}>Contacto</th>
                  <th style={th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {items.map(s => (
                  <tr key={s._id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={td}>{s.nombre}</td>
                    <td style={td}>{s.docTipo || 80}-{s.docNro || ''}</td>
                    <td style={td}>{s.condicionIVA}</td>
                    <td style={td}>{s.email || '-'} {s.telefono ? ` / ${s.telefono}` : ''}</td>
                    <td style={{ ...td, whiteSpace: 'nowrap' }}>
                      <button onClick={() => openEdit(s)} style={btn('#6f42c1')}>✏️ Editar</button>{' '}
                      <button onClick={() => onDelete(s)} style={btn('#dc3545')}>🗑️ Eliminar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          </>
        )}
      </div>

      {modalOpen && (
        <div style={overlay} onClick={() => setModalOpen(false)}>
          <div style={modal} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>{editing ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h3>
            <form onSubmit={onSubmit}>
              <div className="form-grid" style={{ gap: 12 }}>
                <label style={lbl}>Nombre<input style={input} value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required/></label>
                <label style={lbl}>CUIT/DNI<input style={input} value={form.docNro} onChange={(e) => setForm({ ...form, docNro: e.target.value })}/></label>
                <label style={lbl}>Email<input style={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}/></label>
                <label style={lbl}>Teléfono<input style={input} value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })}/></label>
                <label style={lbl} className="full">Dirección<input style={input} value={form.direccion} onChange={(e) => setForm({ ...form, direccion: e.target.value })}/></label>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setModalOpen(false)} style={btn('#6c757d')}>Cancelar</button>
                <button type="submit" style={btn('#667eea')}>{editing ? 'Guardar' : 'Crear'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const card = { background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' };
const th = { textAlign: 'left', padding: 12, fontWeight: 700, fontSize: 14 };
const td = { textAlign: 'left', padding: 12, fontSize: 14 };
const input = { padding: '8px 10px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, width: '100%' };
const lbl = { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 12, color: '#555' };
const btn = (bg) => ({ padding: '8px 12px', background: bg, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' });
const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
const modal = { background: '#fff', borderRadius: 12, padding: 20, width: 600, maxWidth: '95vw' };

export default Suppliers;
